import { Reveal } from "./Reveal";

export default function SectionHeading({
  index,
  eyebrow,
  title,
  copy,
  dark = false,
  align = "left",
  className = "",
}) {
  return (
    <Reveal
      className={`${align === "center" ? "mx-auto text-center" : ""} max-w-3xl ${className}`}
    >
      <div
        className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}
      >
        {index && (
          <span className="font-display text-base italic text-champagne">
            ({index})
          </span>
        )}
        <p className={dark ? "eyebrow-light" : "eyebrow"}>{eyebrow}</p>
        <span
          className={`h-px w-12 ${dark ? "bg-champagne/50" : "bg-champagne"}`}
          aria-hidden="true"
        />
      </div>
      <h2
        className={`mt-5 font-display text-[clamp(2rem,4.5vw,3.25rem)] font-medium leading-[1.06] ${
          dark ? "text-ivory" : "text-ink"
        }`}
      >
        {title}
      </h2>
      {copy && (
        <p
          className={`mt-5 text-base leading-relaxed md:text-lg ${
            dark ? "text-ivory/70" : "text-soften"
          }`}
        >
          {copy}
        </p>
      )}
    </Reveal>
  );
}
